import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Checkbox } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
import {
    addActiveTableRow,
    removeActiveTableRow
    // @ts-ignore
} from 'services/selectedTableCells/actions';

// Selectors
import {
    makeSelectIsRowActive,
    makeSelectAreSomeRowsActive
    // @ts-ignore
} from 'services/selectedTableCells/selectors';

interface OwnProps {
    rowId: string | string[];
}

interface ConnectedProps {
    checked?: boolean;
    indeterminate?: boolean;
}

interface DispatchProps {
    addActiveTableRow: typeof addActiveTableRow;
    removeActiveTableRow: typeof removeActiveTableRow;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class ActiveTableCellRowCheckbox extends React.PureComponent<Props> {
    handleChange = (): void => {
        const { rowId, checked, indeterminate } = this.props;

        if (checked || indeterminate) {
            this.props.removeActiveTableRow(rowId);
        } else {
            this.props.addActiveTableRow(rowId);
        }
    };

    handleClick = (event: React.MouseEvent<HTMLInputElement>): void => {
        event.stopPropagation();
    };

    render(): React.ReactElement {
        const { checked, indeterminate } = this.props;
        return (
            <Checkbox
                onChange={this.handleChange}
                onClick={this.handleClick}
                checked={checked}
                indeterminate={!checked && indeterminate}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    checked: makeSelectIsRowActive(),
    indeterminate: makeSelectAreSomeRowsActive()
});

export default connect(
    mapStateToProps,
    {
        addActiveTableRow,
        removeActiveTableRow
    }
)(ActiveTableCellRowCheckbox);
